import React, { useMemo } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

export const Column = (props) => {
  return <span {...props}></span>;
};

export const Table = (props) => {
  const { data, children } = props;

  const columns = useMemo(() => {
    return (children || []).map((child) => {
      return child.props;
    });
  }, [children]);

  return (
    <table className="database-table-component">
      <thead>
        <tr>
          {columns.map((column) => {
            if (column.dataIndex) {
              return (
                <th key={column.key || column.dataIndex}>{column.title}</th>
              );
            } else {
              return null;
            }
          })}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          const cls = classNames({ even: index % 2 });
          return (
            <tr className={cls}>
              {columns.map((column) => {
                const value = item[column.dataIndex];
                if (value) {
                  return (
                    <td key={column.key || column.dataIndex}>
                      {column.render ? column.render(value, item) : value}
                    </td>
                  );
                } else {
                  return null;
                }
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
export const DatabaseTable = () => {
  const { t } = useTranslation();
  const data = [
    {
      title: t("learn.databasePage.table.supported"),
      authing: "supported",
      auth0: "supported",
      okta: "unsupported",
      aliyun: "unsupported",
      yufu: "unsupported",
      zhuyun: "unsupported",
    },
  ];
  const mobileData = [
    {
      title: "Authing",
      supported: "supported",
    },
    {
      title: "Auth0",
      supported: "supported",
    },
    {
      title: "Okta",
      supported: "unsupported",
    },
    {
      title: t("learn.databasePage.table.item4.title"),
      supported: "unsupported",
    },
    {
      title: t("learn.databasePage.table.item5.title"),
      supported: "unsupported",
    },
    {
      title: t("learn.databasePage.table.item6.title"),
      supported: "unsupported",
    },
  ];
  const renderChecked = (value) => {
    const checkedIconStyl = {
      color: "#396aff",
      textAlign: "center",
      display: "block",
      marginRight: "10px",
      transform:"scale(1.2)"
    };
    const uncheckedIconStyl = {
      color: "#ddd",
      textAlign: "center",
      display: "block",
      marginRight: "10px",
      transform:"scale(1.2)"      
    };
    const checkedIcon = (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <i
          className="icon authing-icon authing-checkbox-circle-fill"
          style={checkedIconStyl}
        ></i>
      </div>
    );
    const uncheckedIcon = (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <i
          className="icon authing-icon authing-close-circle-fill"
          style={uncheckedIconStyl}
        ></i>
      </div>
    );
    return value === "supported" ? checkedIcon : uncheckedIcon;
  };
  const renderTitle = (value, data) => {
    return (
      <div className="colum-title">
        <span>{value}</span>
      </div>
    );
  };
  const renderPcTable = () => {
    return (
      <div className="pc-table">
        <Table data={data}>
          <Column
            title={t("learn.databasePage.table.manufacturer")}
            dataIndex="title"
            align=""
            render={renderTitle}
          />
          <Column
            title="Authing"
            dataIndex="authing"
            align=""
            render={renderChecked}
          />
          <Column
            title="Auth0"
            dataIndex="auth0"
            align=""
            render={renderChecked}
          />
          <Column
            title="Okta"
            dataIndex="okta"
            align="center"
            render={renderChecked}
          />
          <Column
            title={t("learn.databasePage.table.item4.title")}
            dataIndex="aliyun"
            align="center"
            render={renderChecked}
          />
          <Column
            title={t("learn.databasePage.table.item5.title")}
            dataIndex="yufu"
            align="center"
            render={renderChecked}
          />
          <Column
            title={t("learn.databasePage.table.item6.title")}
            dataIndex="zhuyun"
            align="center"
            render={renderChecked}
          />
        </Table>
      </div>
    );
  };
  const renderMobileTable = () => {
    return (
      <div className="mobile-table">
        <Table data={mobileData}>
          <Column
            title={t("learn.databasePage.table.manufacturer")}
            dataIndex="title"
            align=""
            render={renderTitle}
          />
          <Column
            title={t("learn.databasePage.table.supported")}
            dataIndex="supported"
            align="center"
            render={renderChecked}
          />
        </Table>
      </div>
    );
  };
  return (
    <section className="databasePage-table">
      <div className="inner">
        <div className="title">{t("learn.databasePage.table.title")}</div>
        <div className="subtitle">{t("learn.databasePage.table.subtitle")}</div>
        {renderPcTable()}
        {renderMobileTable()}
      </div>
    </section>
  );
};
